<template>
	<div class="data-ingredient">
		<div class="page-header">菜品</div>
		<dishes-search @handleAdd="handleAdd" @changeDataMode="changeDataMode" @search="search"></dishes-search>
		<el-row :gutter="15" style="padding:15px" v-if="dataModel">
			<el-col style="width:210px;height:180px;margin-bottom:12px" v-for="item in dishesList" :key="item.id">
				<di-card shadow="hover" :data="item" :body-style="{ 'padding': '0px' }" :view-style="{'height': '150px','lineHeight': '150px'}" 
					@view="view"
					@edit="edit"
					@link="link">
      			<img v-if="item.dishesImageUrl" :src="item.dishesImageUrl+'?x-oss-process=image/resize,m_fill,h_150,w_200'" class="image">
						<el-image v-else
							style="width: 200px; height: 150px;"
							:src="item.dishesImageUrl"
							fit="cover">
							<div slot="error" class="image-slot" style="height:150px;">
										<div class="el-image__error">暂无图片</div>
									</div>
							</el-image>
						<div style="padding: 5px;">
							<span>{{item.dishesName}}</span>
						</div>
    			</di-card>
			</el-col>
		</el-row>
		<div style="padding:15px 0 15px 15px" v-else>
      <el-table ref="dishesTable"
                :data="dishesList"
                style="width: 100%;"
                v-loading="listLoading">
        <el-table-column label="菜名"  align="center"> 
					<template slot-scope="scope">
						 <el-button size="mini"
                       type="text"
                       @click="view(scope.row)">
              {{scope.row.dishesName}}
            </el-button>
					</template>
        </el-table-column>
        <el-table-column label="类别" prop="bigCateName" align="center">
        </el-table-column>
        <el-table-column label="功效" align="center" prop="efficacyStr">
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button size="mini"
                       type="text"
                       @click="edit(scope.row)">
              编辑基本信息
            </el-button>
            <el-button size="mini"
                       type="text"
                       @click="link(scope.row)">编辑适用信息
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
		<div style="display: inline-block;float: right;">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="dishesListQuery.pageNumber"
        :page-size="dishesListQuery.pageSize"
        :page-sizes="[10,15,20]"
        :total="total">
      </el-pagination>
    </div>
		<el-drawer
			title="我是标题"
			:visible.sync="drawer"
			:with-header="false"
			size="290px">
			<div style="padding:15px" v-loading.lock="fullscreenLoading">
				<el-card :body-style="{ padding: '0px' }" shadow="never">
				<el-card :body-style="{ padding: '0px' }" shadow="never">
				<img v-if="dishesModel.dishesImageUrl" :src="dishesModel.dishesImageUrl+'?x-oss-process=image/resize,m_fill,h_175,w_280'" class="image">
				<el-image v-else
					style="width: 280px; height: 175px;"
					fit="cover">
					<div slot="error" class="image-slot" style="height:175px;">
								<div class="el-image__error">暂无图片</div>
							</div>
				</el-image>
				</el-card>
				</el-card>
			</div>
			<div style="padding:0 15px 0 15px;text-align:left;">
				<span style="font-size: 16px;font-weight: bold;display: inline-block;margin-right: 20px;">{{dishesModel.dishesName}}</span>
				<span>{{dishesModel.halalFlag==1?'清真':'非清真'}}</span>
			</div>
			<div style="padding:5px">
				<table style="width: 100%;">
					<tr>
						<td class="detail-title">类       别：</td><td class="detail-title__t">{{dishesModel.bigCateName}} {{dishesModel.smallCateName}}</td>
						<td class="detail-title">荤       素：</td><td class="detail-title__t">{{dishesModel.meatVegetables==1?'荤菜':'素菜'}}</td>	
					</tr>
					<tr>
						<td class="detail-title">烹饪技法：</td><td class="detail-title__t">{{dishesModel.techniqueDictName}}</td>
						<td class="detail-title">别       名：</td><td class="detail-title__t">{{dishesModel.aliasName}}</td>	
					</tr>
				</table>
				<table style="width: 100%;">
					<tr>
						<td class="detail-title">功效作用：</td><td class="detail-title__t">{{dishesModel.efficacy | filterDicts}}</td>
					</tr>
					<tr>
						<td class="detail-title">适宜人群：</td><td class="detail-title__t">{{dishesModel.crowd | filterDicts}}</td>
					</tr>
					<tr>
						<td class="detail-title">色泽特点：</td><td class="detail-title__t">{{dishesModel.colorDictName}}</td>
					</tr>
					<tr>
						<td class="detail-title">菜品特点：</td><td class="detail-title__t">{{dishesModel.features | filterDicts}}</td>
					</tr>
				</table>
			</div>
			<div style="padding: 0 5px 5px 5px;position: relative;">
				<el-tabs v-model="activeName"  @tab-click="handleClick">
					<el-tab-pane label="食材搭配" name="first">
						<el-row>
							<el-col :span="12" style="text-align:left;">
								<el-row v-for="(val, key) in ingredientsData.ingredientsMap" :key="key">
									<el-col :span="20">
										<span style="display:inline-block;margin-bottom:6px;">{{key | filterKeyName}}</span>
										<div v-for="(item, index) in val" :key="index" style="padding-left: 10px;">
											<span class="ingredients_map_name">{{item.ingredientsName}}</span>
											<span class="ingredients_map_weight">{{item.weight}} 克</span>
										</div>
									</el-col>
								</el-row>
							</el-col>
							<el-col :span="12" style="text-align: left;">
								<div style="text-align: left;margin-bottom: 6px;">营养素</div>
								<div>
								<table style="width: 100%" class="ingredients_map">
									<tr>
										<td style="width:65px;">能量</td>
										<td>{{ingredientsData.energyKc | numFilter}}</td>
										<td>千卡</td>
									</tr>
									<tr>
										<td>碳水化合物</td>
										<td>{{ingredientsData.carbohydrate | numFilter}}</td>
										<td>克</td>
									</tr>
									<tr>
										<td>蛋白质</td>
										<td>{{ingredientsData.protein | numFilter}}</td>
										<td>克</td>
									</tr>
									<tr>
										<td>钙</td>
										<td>{{ingredientsData.autunite | numFilter}}</td>
										<td>毫克</td>
									</tr>
									<tr>
										<td>铁</td>
										<td>{{ingredientsData.iron | numFilter}}</td>
										<td>毫克</td>
									</tr>
									<tr>
										<td>锌</td>
										<td>{{ingredientsData.zicn | numFilter}}</td>
										<td>毫克</td>
									</tr>
									<tr>
										<td>维生素A</td>
										<td>{{ingredientsData.va | numFilter}}</td>
										<td>微克</td>
									</tr>
									<tr>
										<td>维生素B1</td>
										<td>{{ingredientsData.vb1 | numFilter}}</td>
										<td>毫克</td>
									</tr>
									<tr>
										<td>维生素B2</td>
										<td>{{ingredientsData.vb2 | numFilter}}</td>
										<td>毫克</td>
									</tr>
									<tr>
										<td>维生素C</td>
										<td>{{ingredientsData.vc | numFilter}}</td>
										<td>毫克</td>
									</tr>
								</table>
							</div>
							</el-col>
						</el-row>
					</el-tab-pane>
					<el-tab-pane label="适用信息" name="second">
						<el-row style="text-align:left">
							<span class="child-content">季节常用性</span>
							<el-divider></el-divider>
							<div v-for="(item, index) in seasonsList" :key="index">
								<el-row>
									<el-col :span="3">
										{{item.name}}
									</el-col>
									<el-col :span="21">
										<div v-for="(sea, index) in item.months" :key="index">
											<el-row>
												<el-col :span="3">
													{{sea.monthName}}
												</el-col>
												<el-col :span="21">
													<el-progress :text-inside="true" :stroke-width="16" :percentage="sea.value" :color="customColors" :format="formatProgress"></el-progress>
												</el-col>
											</el-row>
										</div>
									</el-col>
								</el-row>
							</div>
							<el-divider></el-divider>
							<span class="child-content">地域常用性</span>
							<el-row v-for="(val, key) in dishesModel.area" :key="key" style="margin-top: 10px;">
								<el-col :span="3">
									{{key}}
								</el-col>
								<el-col :span="21">
									<span v-for="(item, index) in val" :key="index" style="display:block;margin-bottom:6px">
										<span class="child-content" style="text-align:left;width: 96px;display: inline-block;margin-left:15px;">{{item.areaName}}</span>
										<span class="child-content" style="text-align:left;width: 45px;display: inline-block;color:rgb(116, 115, 116);margin-left:15px;">{{item.valueDictName != null?item.valueDictName:'不常用'}}</span>
									</span>
								</el-col>
							</el-row>
						</el-row>
					</el-tab-pane>
					<!-- <el-tab-pane label="相似菜品" name="third">
						<el-row :gutter="15">
							<el-col style="width:135px;height:75px;margin-bottom:45px" v-for="item in likeDishesList" :key="item.id">
								<el-card shadow="never" :body-style="{ padding: '0px' }">
									<img v-if="item.dishesImageUrl"  :src="item.dishesImageUrl+'?x-oss-process=image/resize,m_fill,h_75,w_120'" class="image">
									<el-image v-else
										style="width: 120px; height: 75px;"
										fit="cover">
										<div slot="error" class="image-slot" style="height:75px;">
													<div class="el-image__error">暂无图片</div>
												</div>
										</el-image>
									<div style="padding: 5px;">
										<span>{{item.dishesName}}</span>
									</div>
								</el-card>
							</el-col>
						</el-row>	
					</el-tab-pane> -->
				</el-tabs>
				<span style="position: absolute;top: 15px;right: 15px;cursor:pointer" v-if="switched" @click="queryLikeDishesPage(dishesModel.id)">换一批</span>
			</div>
		</el-drawer>
	</div>
</template>
<script>
import DishesSearch from './dishes_search.vue'
import DiCard from '@/views/datacenter/components/basedata/dicard.vue'
import { fetchDishesList,queryDishesDetail,queryIngredientsList,queryLikeDishes } from '@/api/catering/dishes'
import dicardVue from '../dicard.vue';

const defaultListQuery = {
    pageNumber: 1,
    pageSize: 20
};
const defaultLikeDishesQuery = {
	dishesId: null,
	pageNumber: 1,
	pageSize: 10
};
export default {
	name: "KidDishes",
	components:{
		DishesSearch,
		DiCard
	},
	created() {
		if(this.$route.params.page) {
			this.dishesListQuery.pageNumber = this.$route.params.page;
		}
		// this.loadDishesList(this.dishesListQuery);
	},
	filters:{
		filterDicts(dictArray) {
			if(dictArray) {
				let str = "";
				dictArray.map(item=>{
					str += item.itemDictName+ " ";
				})
				return str;
			}
		},
		filterFeatures(array) {
			if(array) {
				let str = "";
				array.map(item=>{
					str += item.valueDictName+ " ";
				})
				return str;
			}
		},
		filterKeyName(value) {
			if(value == 1) {
				return '主料';
			}
			if(value == 2) {
				return '辅料';
			}
			if(value == 3) {
				return '调料';
			}
			if(value == 4) {
				return '可扩展辅料';
			}
		},
		numFilter(value) {
      const realVal = parseFloat(value).toFixed(2);
      return realVal;
    }
	},
  data() {
    return {
			dataModel: true,
			dishesListQuery: Object.assign({}, defaultListQuery),
			dishesList: [],
			total: null,
			dishesModel: {
				ingSrc: 'https://kiddishes.oss-cn-hangzhou.aliyuncs.com/baicai.jpg?x-oss-process=image/resize,m_fill,h_210,w_280'
			},
			activeName: "first",
			isShow: false,
			drawer: false,
			fullscreenLoading: true,
			listLoading: false,
			percentage: 20,
      customColors: [
				{color: '#919191', percentage: 10},
				{color: '#73d13d', percentage: 20},
				{color: '#fcca00', percentage: 40},
				{color: '#ff9502', percentage: 60},
				{color: '#ff3d00', percentage: 80},
				{color: '#cf1322', percentage: 100}
      ],
			seasonsList:[],
			ingredientsData: {
				ingredientsMap: []
			},
			likeDishesList: [],
			likeDishesCount: 0,
			likeDishesQuery: Object.assign({},defaultLikeDishesQuery),
			switched: false
    };
  },
  methods: {
		loadDishesList(params) {
			this.listLoading = true;
			fetchDishesList(params).then(response=>{
				this.listLoading = false;
        this.dishesList = response.data.records;
        this.total = response.data.total;
			})
		},
		handleSizeChange(val) {
        this.dishesListQuery.pageNumber = 1;
        this.dishesListQuery.pageSize = val;
        this.loadDishesList(this.dishesListQuery);
      },
    handleCurrentChange(val) {
        this.dishesListQuery.pageNumber = val;
        this.loadDishesList(this.dishesListQuery);
    },
		search(query) {
			this.dishesListQuery = Object.assign(query,defaultListQuery);
			this.loadDishesList(this.dishesListQuery);
		},
		changeDataMode(val) {
			this.dataModel = val;
		},
		view(data) {
			this.dishesModel = {};
			this.ingredientsData = {ingredientsMap:[]};
			this.likeDishesList = [];
			this.likeDishesQuery = Object.assign({},defaultLikeDishesQuery);
			this.fullscreenLoading = false;
			this.drawer = true;
			queryDishesDetail(data.id).then(response=>{
				this.dishesModel = response.data;
				if(this.dishesModel.season) {
					this.seasonsList = [
						{name: '春季',months:[]},
						{name: '夏季', months:[]},
						{name: '秋季', months:[]},
						{name: '冬季', months:[]}
					];
					this.seasonsList.map((sea,index)=>{
						this.dishesModel.season.map(item=>{
							let value = item.valueDictValue;
							if(value == 0) {
								value = 10;
							} else {
								value = value * 20;
							}
							if(index == 0 && (item.itemDictValue==3 || item.itemDictValue==4 || item.itemDictValue==5)) {
								sea.months.push({monthName: item.itemDictName, value: value});
							}
							if(index == 1 && (item.itemDictValue==6 || item.itemDictValue==7 || item.itemDictValue==8)) {
								sea.months.push({monthName: item.itemDictName, value: value});
							}
							if(index == 2 && (item.itemDictValue==9 || item.itemDictValue==10 || item.itemDictValue==11)) {
								sea.months.push({monthName: item.itemDictName, value: value});
							}
							if(index == 3 && (item.itemDictValue==12 || item.itemDictValue==1 || item.itemDictValue==2)) {
								sea.months.push({monthName: item.itemDictName, value: value});
							}
						})
					})
				}
				this.queryIngredients(data.id, 1);
				this.queryLikeDishesList(data.id);
			})
		},
		formatProgress(percentage) {
			if(percentage == 10) {
				return '不吃'
			}
			if(percentage == 20) {
				return '一月一次'
			}
			if(percentage == 40) {
				return '两周一次'
			}
			if(percentage == 60) {
				return '每周一次'
			}
			if(percentage == 80) {
				return '两周两次'
			}
			if(percentage == 100) {
				return '每日一次'
			}
		},
		queryIngredients(dishesId,crowdDictValue) {
			queryIngredientsList(dishesId, crowdDictValue).then(response=>{
				if(response.data) {
					this.ingredientsData = response.data;
				}
			})
		},
		queryLikeDishesList(dishesId) {
			this.likeDishesQuery.dishesId = dishesId;
			queryLikeDishes(this.likeDishesQuery).then(response=>{
				this.likeDishesList = response.data.records;
				this.likeDishesCount = response.data.total;
			})
		},
		queryLikeDishesPage(dishesId){
			this.likeDishesQuery.pageNumber = this.likeDishesQuery.pageNumber+1;
			this.queryLikeDishesList(dishesId);
		},
		edit(data) {
			this.$router.push({path:'/datacenter/dishes/dishes_info/',query:{uid:data.id,page:this.dishesListQuery.pageNumber}})
		},
		link(data) {
			this.$router.push({'path':'/datacenter/dishes/dishes_apply_info',query:{uid:data.id,page:this.dishesListQuery.pageNumber}})
		},
		handleAdd() {
			this.$router.push({'path':'/datacenter/dishes/dishes_info'})
		},
		handleClick(tab) {
			if(tab.name == 'third') {
				this.switched = true;
			} else {
				this.switched = false;
			}
		}
  }
};
</script>
<style lang="scss">
.detail-title	{
		white-space: pre-wrap;
		height: 25px;
		// display: block;
    // padding-bottom: 10px;
}
.detail-title__t {
	text-align: left;
}
.detail-title__o {
	text-align: left;
}
.child-content {
	display: inline-block;margin-right: 10px;
}
.el-progress-bar__outer {
    height: 6px;
    border: 1px solid #cccccc;
    border-radius: inherit;
    margin-bottom: 5px;
    background-color: white;
    overflow: hidden;
    position: relative;
    vertical-align: middle;
}
.el-progress-bar__inner {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    background-color: #409EFF;
    text-align: right;
    border-radius: inherit;
    line-height: 1;
    white-space: nowrap;
    -webkit-transition: width .6s ease;
    transition: width .6s ease;
}
.ingredients_map_name {
    // width: 80px;
    display: inline-block;
    margin-bottom: 6px;
}
.ingredients_map_weight{
	// width: 40px;
    display: block;
    float: right;
}
.ingredients_map_unit {
	text-align: left;
	display: inline-block;
  padding-left: 10px;
}
</style>






// WEBPACK FOOTER //
// src/views/datacenter/components/basedata/dishes/index.vue